<template src='./form-setup.html'></template>

<script>
import Vue from 'vue'
import { EventBus } from '@/router/bus'
import ContextPage from '@/components/misc/context-page/ContextPage.vue'
import SimpleMDE from 'simplemde/dist/simplemde.min.js'
import { JSONEditor } from '@json-editor/json-editor/'
import { hasAdminClaim, hasMeiClaim, hasFormManageClaim, authorizedOrganizationId, hasFormImportantManage } from '@/router/auth'
import FormAction from '@/components/misc/form-action/FormAction'
import FormExport from '@/components/misc/form-export/FormExport'
import FormImport from '@/components/misc/form-import/FormImport'
import FormValidation from '../form-validation/FormValidation.vue'

export default {
  components: {
    ContextPage,
    SimpleMDE,
    'form-action': FormAction,
    'form-export': FormExport,
    'form-import': FormImport,
    'form-validation': FormValidation
  },
  props: ['phaseTitle', 'helpUrl', 'markdownElements'],
  data () {
    return {
      isEditorDisabled: false,
      revisionErrors: [],
      revisionWarnings: [],
      resultContent: null,
      initialSchema: {},
      initialEditor: {},
      initialConfig: {},
      initialVal: {},
      formChanged: false,
      jsonScheme: null,
      pif: null,
      editor: null,
      projectCode: this.$route.params.projectCode,
      projectPhaseId: this.$route.params.projectPhaseId,
      phaseFormId: this.$route.params.phaseFormId,
      revision: {
        revision: Number(this.$route.params.revision)
      },
      revisions: [],
      formCode: '',
      formName: '',
      formStatus: 0,
      project: {},
      loading: false,
      PhaseStatus: {
        ENTRY: 1,
        WAITINGCONFIRMATION: 2,
        WAITINGAPPROVAL: 3,
        APPROVED: 4,
        RATIONALIZATIONPROPOSAL: 5,
        WAITINGCOMMISSIONDECISION: 6,
        CORRECTION: 7,
        POSTPONED: 8,
        STOPPED: 9,
        ACCEPTEDRATIONALIZATION: 10,
        CANCELED: 11,
        VERIFICATIONSEND: 19,
        VERIFICATION: 20,
        MINISTERSEND: 21,
        MINISTER: 22,
        CORRECTIOAMENDMENT: 29,
        RATIONALIZATIONPOSTPONED: 30,
        RATIONALIZATIONSHUTDOWN: 31
      },
      ProjectStatus: {
        PENDING: 0,
        FINISHED: 1
      },
      FormInputAction: {
        SAVE: 1,
        LOCK: 2,
        UNLOCK: 3
      },
      FormInputStatus: {
        UNLOCKED: 1,
        LOCKED: 2,
        MARKED: 3,
        APPROVED: 4
      },
      status: [
        {
          color: 'pending',
          text: this.$t('projects.formStatuses.1')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.2')
        },
        {
          color: 'active-light',
          text: this.$t('projects.formStatuses.3')
        },
        {
          color: 'success',
          text: this.$t('projects.formStatuses.4')
        }
      ]
    }
  },
  computed: {
    isAdmin () {
      return hasAdminClaim()
    },
    isMei () {
      return hasMeiClaim()
    },
    isEuFunds () {
      return this.project.foreignFunds
    },
    canManageForm () {
      return hasFormManageClaim() && this.project.status === this.ProjectStatus.PENDING
    },
    canManageImportant () {
      return hasFormImportantManage() && this.project.status === this.ProjectStatus.PENDING
    },
    userOrganizationId () {
      return authorizedOrganizationId()
    },
    canEditProject () {
      // console.log('trt')
      // console.log(this.project)
      // console.log(this.canManageImportant)
      // console.log(this.project.phase === 3)
      // console.log(this.formStatus === this.FormInputStatus.UNLOCKED)
      // console.log(this.userOrganizationId === this.project.organizationId)
      return this.formStatus === this.FormInputStatus.UNLOCKED &&
             ((this.canManageForm && this.project.phase !== 3) || (this.canManageImportant && this.project.phase === 3)) &&
             (this.userOrganizationId === this.project.organizationId || this.project.phase === 3) &&
             Number(this.projectPhaseId) === this.project.projectPhaseId &&
             (this.project.phaseStatus === this.PhaseStatus.ENTRY || this.project.phaseStatus === this.PhaseStatus.CORRECTIOAMENDMENT)
    },
    canAddAdditionalComments () {
      return (Number(this.projectPhaseId) === this.project.projectPhaseId && hasAdminClaim() && (this.project.phaseStatus === this.PhaseStatus.APPROVED || this.project.phaseStatus === this.PhaseStatus.RATIONALIZATIONPOSTPONED || this.project.phaseStatus === this.PhaseStatus.RATIONALIZATIONSHUTDOWN)) ||
             (Number(this.projectPhaseId) === this.project.projectPhaseId && hasMeiClaim())
    },
    canUnlockProject () {
      return this.formStatus === this.FormInputStatus.LOCKED &&
      ((this.canManageForm && this.project.phase !== 3) || (this.canManageImportant && this.project.phase === 3)) &&
      (this.userOrganizationId === this.project.organizationId || this.project.phase === 3) &&
      Number(this.projectPhaseId) === this.project.projectPhaseId &&
      (this.project.phaseStatus === this.PhaseStatus.MINISTERSEND || this.project.phaseStatus === this.PhaseStatus.ENTRY || this.project.phaseStatus === this.PhaseStatus.CORRECTIOAMENDMENT)
    },
    hasRevisions () {
      return this.revisions.length > 0
    }
  },
  methods: {
    changeRevision () {
      EventBus.$emit('changeRevision', this.revision.revision)
    },
    formatRevisions (jsonRevisions, formName, displayAppropriationsWarning) {
      const revisions = jsonRevisions ? JSON.parse(jsonRevisions) : []
      for (var j = 0; j < revisions.length; j++) {
        revisions[j].text = revisions[j].revision + ' - ' + this.formatDate(revisions[j].last_changed_date) + ' - ' + revisions[j].last_changed_user_name
      }
      this.revisions = revisions
      if (!this.revision.revision) {
        this.revision = this.revisions[0]
        if (this.revision) {
          history.pushState({}, null, ('/projects/' + this.projectCode + '/phases/' + Number(this.projectPhaseId) + '/forms/' + formName + '/id/' + Number(this.phaseFormId) + '/revision/' + this.revision.revision))
        }
      } else {
        this.revision = this.revisions.filter(x => x.revision === this.revision.revision)[0]
        if (this.revision.revision !== this.revisions[0].revision) {
          this.changeRevision()
        }
      }
      if (displayAppropriationsWarning) {
        if (this.revision && this.revision.validation) {
          const validation = JSON.parse(this.revision.validation)
          const notSelectedAppropriations = { Index: 0, StatusCode: { Code: 'FluentEmptyProjectFormAppropriations' } }
          validation.Warnings.unshift(notSelectedAppropriations)
          this.revision.validation = JSON.stringify(validation)
        }
      }
    },
    configureEditor () {
      const el = document.getElementById('editorHolder')
      this.initialConfig.schema = this.initialSchema
      this.initialConfig.no_additional_properties = true
      this.initialConfig.required_by_default = true
      if ((this.revision && this.revision.revision !== this.revisions[0].revision) || !this.canEditProject || this.formStatus !== this.FormInputStatus.UNLOCKED) {
        this.initialConfig.disable_array_add = true
        this.initialConfig.disable_array_delete = true
        this.initialConfig.disable_array_delete_all_rows = true
        this.initialConfig.disable_array_delete_last_row = true
        this.initialConfig.disable_array_reorder = true
      }
      if (this.editor) { this.editor.destroy() }
      JSONEditor.defaults.languages.en = this.$t('jsonEditor')
      JSONEditor.defaults.callbacks.template = {
        sumAllValues: (jsoneditor, data) => {
          const values = Object.entries(data)
            .filter(([key]) => key !== 'self')
            .map(([, value]) => value)
          const sum = this.sum(values)
          return sum ? this.formatAmount(sum, 0) : null
        },
        copyValue: (jsoneditor, data) => {
          return data.value_1
        },
        diffPercentage: (jsoneditor, data) => {
          const values = Object.entries(data)
            .filter(([key]) => key !== 'self')
            .map(([, value]) => Number(value?.toString().replaceAll('.', '').replaceAll(',', '.')))
          const percent = this.formatAmount((values[1] - values[0]) / values[0] * 100)
          return percent || null
        },
        subtractValues: (jsoneditor, data) => {
          const values = Object.entries(data)
            .filter(([key]) => key !== 'self')
            .map(([, value]) => Number(value?.toString().replaceAll('.', '').replaceAll(',', '.')))
          return this.formatAmount(values[0] - values[1]) || null
        },
        getYearsRange: () => {
          const currentYear = new Date().getFullYear()
          const startYear = currentYear - 20
          const endYear = currentYear + 20

          return Array.from({ length: endYear - startYear + 1 }, (_, i) => startYear + i)
        },
        percentage: (jsoneditor, data) => {
          if (!data) return
          const firstValue = data.value_1 && data.value_1.toString().replaceAll('.', '').replaceAll(',', '.')
          const secondValue = data.value_2 && data.value_2[jsoneditor.parent?.key] && data.value_2[jsoneditor.parent?.key]['local amount'].toString().replaceAll('.', '').replaceAll(',', '.')
          return this.formatAmount(secondValue / firstValue * 100)
        },
        foreignAmount: (jsoneditor, data) => {
          if (!data || !data.sources || !data.sources[jsoneditor.parent?.key]) return
          const localAmount = data.sources[jsoneditor.parent?.key]['local amount'].toString().replaceAll('.', '').replaceAll(',', '.')
          const exchangeRate = data.sources[jsoneditor.parent?.key].currency.toString() && data.sources[jsoneditor.parent?.key].currency.toString().split(' ')[1] && data.sources[jsoneditor.parent?.key].currency.toString().split(' ')[1].replaceAll('.', '').replaceAll(',', '.')
          const currency = data.sources[jsoneditor.parent?.key].currency.toString() && data.sources[jsoneditor.parent?.key].currency.toString().split(' ')[0] && data.sources[jsoneditor.parent?.key].currency.toString().split(' ')[0]
          if (currency === 'RSD') {
            return ''
          } else {
            return this.formatAmount(localAmount / exchangeRate, 0)
          }
        },
        exchangeAmount: (jsoneditor, data) => {
          if (!data || !data.funds || !data.funds[jsoneditor.parent?.key]) return
          const amount = data.funds[jsoneditor.parent?.key].amount.toString().replaceAll('.', '').replaceAll(',', '.')
          const exchangeRate = data.funds[jsoneditor.parent?.key].currency.toString() && data.funds[jsoneditor.parent?.key].currency.toString().split(' ')[1] && data.funds[jsoneditor.parent?.key].currency.toString().split(' ')[1].replaceAll('.', '').replaceAll(',', '.')
          const currency = data.funds[jsoneditor.parent?.key].currency.toString() && data.funds[jsoneditor.parent?.key].currency.toString().split(' ')[0] && data.funds[jsoneditor.parent?.key].currency.toString().split(' ')[0]
          if (currency === 'RSD') {
            return ''
          } else {
            return this.formatAmount(amount / exchangeRate)
          }
        }
      }
      this.editor = new JSONEditor(el, this.initialConfig)
      this.resultContent = this.initialEditor
    },
    configureMarkdownElement (markdownElement) {
      if (this.editor.getEditor(markdownElement.editor)) {
        if (this.editor.getEditor(markdownElement.editor).simplemde_instance) {
          this.editor.getEditor(markdownElement.editor).simplemde_instance.toTextArea()
        }
        this.editor.getEditor(markdownElement.editor).simplemde_instance = null
      }

      const config = {
        element: document.getElementsByName(markdownElement.element)[0],
        spellChecker: false,
        autosave: { enabled: true },
        status: ['autosave', 'lines', 'words', 'cursor'],
        insertTexts: {
          table: ['', '\n\n| ' + this.$t('markdown.column') + 1 + ' | ' + this.$t('markdown.column') + 2 + ' | ' + this.$t('markdown.column') + 3 + ' |\n| ------- | ------- | ------- |\n| ' + this.$t('markdown.text') + 1 + '  | ' + this.$t('markdown.text') + 1 + '  | ' + this.$t('markdown.text') + 1 + '  |\n\n']
        },
        toolbar: [
          {
            name: 'bold',
            action: SimpleMDE.toggleBold,
            className: 'fa fa-bold',
            title: this.$t('markdown.bold')
          },
          {
            name: 'italic',
            action: SimpleMDE.toggleItalic,
            className: 'fa fa-italic',
            title: this.$t('markdown.italic')
          },
          {
            name: 'strikethrough',
            action: SimpleMDE.toggleStrikethrough,
            className: 'fa fa-strikethrough',
            title: this.$t('markdown.strikethrough')
          },
          {
            name: 'heading-1',
            action: SimpleMDE.toggleHeading1,
            className: 'fa fa-header fa-header-x fa-header-1',
            title: this.$t('markdown.heading-1')
          },
          {
            name: 'heading-2',
            action: SimpleMDE.toggleHeading2,
            className: 'fa fa-header fa-header-x fa-header-2',
            title: this.$t('markdown.heading-2')
          },
          {
            name: 'heading-3',
            action: SimpleMDE.toggleHeading3,
            className: 'fa fa-header fa-header-x fa-header-3',
            title: this.$t('markdown.heading-3')
          },
          '|',
          {
            name: 'code',
            action: SimpleMDE.toggleCodeBlock,
            className: 'fa fa-code',
            title: this.$t('markdown.code')
          },
          {
            name: 'quote',
            action: SimpleMDE.toggleBlockquote,
            className: 'fa fa-quote-left',
            title: this.$t('markdown.quote')
          },
          {
            name: 'unordered-list',
            action: SimpleMDE.toggleUnorderedList,
            className: 'fa fa-list-ul',
            title: this.$t('markdown.unordered-list')
          },
          {
            name: 'ordered-list',
            action: SimpleMDE.toggleOrderedList,
            className: 'fa fa-list-ol',
            title: this.$t('markdown.ordered-list')
          },
          '|',
          {
            name: 'link',
            action: SimpleMDE.drawLink,
            className: 'fa fa-link',
            title: this.$t('markdown.link')
          },
          {
            name: 'image',
            action: SimpleMDE.drawImage,
            className: 'fa fa-picture-o',
            title: this.$t('markdown.image')
          },
          {
            name: 'table',
            action: SimpleMDE.drawTable,
            className: 'fa fa-table',
            title: this.$t('markdown.table')
          },
          {
            name: 'horizontal-rule',
            action: SimpleMDE.drawHorizontalRule,
            className: 'fa fa-minus',
            title: this.$t('markdown.horizontal-rule')
          },
          '|',
          {
            name: 'preview',
            action: SimpleMDE.togglePreview,
            className: 'fa fa-eye no-disable',
            title: this.$t('markdown.preview')
          },
          {
            name: 'side-by-side',
            action: SimpleMDE.toggleSideBySide,
            className: 'fa fa-columns no-disable no-mobile',
            title: this.$t('markdown.sideBySide')
          },
          {
            name: 'fullscreen',
            action: SimpleMDE.toggleFullScreen,
            className: 'fa fa-arrows-alt no-disable',
            title: this.$t('markdown.fullscreen')
          },
          '|',
          {
            name: 'guide',
            action: Vue.$config.help_root + 'projects/markdown/',
            className: 'fa fa-question-circle',
            title: this.$t('markdown.help')
          }
        ]
      }
      if ((this.revision && this.revision.revision !== this.revisions[0].revision) || !this.canEditProject || this.formStatus !== this.FormInputStatus.UNLOCKED) {
        config.toolbar = false
      }
      if (this.editor.getEditor(markdownElement.editor)) {
        this.editor.getEditor(markdownElement.editor).simplemde_instance = new SimpleMDE(config)
      }
    },
    manageInput () {
      const adminElements = Object.entries(this.editor.editors).filter(([, value]) => value?.options?.admin)
      const meiElements = Object.entries(this.editor.editors).filter(([, value]) => value?.options?.mei)
      // const isdaconElements = Object.entries(this.editor.editors).filter(([, value]) => value?.options?.isdacon)
      if (this.isEuFunds) {
        console.log('Project is eu fund')
        // Disable input if project have isdacon evaluation

        const markdownElements = Object.entries(this.editor.editors).filter(([, value]) => value && value.options?.isdacon && value.simplemde_instance)
        markdownElements.forEach(([key, markdownElement]) => {
          markdownElement.simplemde_instance.togglePreview()
          const markdownElementWrapperEl = markdownElement.simplemde_instance.codemirror?.getWrapperElement()
          markdownElementWrapperEl.classList.add('CodeMirror-read-only')
        })
      }

      if ((this.revision && this.revision.revision !== this.revisions[0].revision) || !this.canEditProject || this.formStatus !== this.FormInputStatus.UNLOCKED) {
        this.editor.disable()
        this.isEditorDisabled = true
        // disable markdown elements that are not marked with admin tag
        const markdownElements = Object.entries(this.editor.editors).filter(([, value]) => value && !value.options?.admin && !value.options?.mei && value.simplemde_instance)
        markdownElements.forEach(([key, markdownElement]) => {
          markdownElement.simplemde_instance.togglePreview()
          const markdownElementWrapperEl = markdownElement.simplemde_instance.codemirror?.getWrapperElement()
          markdownElementWrapperEl.classList.add('CodeMirror-read-only')
        })
      } else {
        this.isEditorDisabled = false
      }
      // TODO: Refactor DRY
      adminElements.forEach(([key, markdownElement]) => {
        console.log(key)
        const opinionSectionEl = document.querySelector(`[data-schemapath="${key}"]`)
        if (!opinionSectionEl) return
        opinionSectionEl.style.display = (this.isAdmin || this.isMei) ? 'block' : 'none'
        opinionSectionEl.classList.add('admin-container')
        // enable markdown elements for admin roles
        if (!this.isAdmin) return
        this.isEditorDisabled = true
        this.editor.getEditor(key).enable()
        if (markdownElement.simplemde_instance) {
          const markdownElementWrapperEl = markdownElement.simplemde_instance.codemirror?.getWrapperElement()
          markdownElementWrapperEl.classList.remove('CodeMirror-read-only')
        }
      })
      // TODO: Refactor DRY
      meiElements.forEach(([key, markdownElement]) => {
        const opinionSectionEl = document.querySelector(`[data-schemapath="${key}"]`)
        if (!opinionSectionEl) return
        opinionSectionEl.style.display = (this.isAdmin || this.isMei) ? 'block' : 'none'
        opinionSectionEl.classList.add('admin-container')
        // enable markdown elements for admin roles
        if (!this.isMei) return
        this.isEditorDisabled = true
        this.editor.getEditor(key).enable()
        if (markdownElement.simplemde_instance) {
          const markdownElementWrapperEl = markdownElement.simplemde_instance.codemirror?.getWrapperElement()
          markdownElementWrapperEl.classList.remove('CodeMirror-read-only')
        }
      })
    },
    saveJsonValues (jsonScheme) {
      for (const key in jsonScheme) {
        var property = this.editor.getEditor('root.' + key)
        if (property) {
          property.setValue('')
          property.setValue(jsonScheme[key])
        } else {
          console.error('Editor not found for key: ' + key)
        }
      }
    },
    backEventAction () {
      window.history.back()
      this.removePopstateEventAction()
    },
    removePopstateEventAction () {
      window.removeEventListener('popstate', this.backEventAction)
    }
  },
  created () {
    EventBus.$on('saveJsonValues', (jsonScheme) => {
      this.jsonScheme = jsonScheme
      this.saveJsonValues(JSON.parse(this.jsonScheme))
    })
    window.addEventListener('popstate', this.backEventAction)
  },
  beforeDestroy () {
    EventBus.$off('saveJsonValues')
  }
}
</script>
<style scoped>
.v-chip {
  font-weight: 600 !important;
  /* font-size: 20px !important */
}
.item-container {
  font-weight: 600 !important;
  font-size: 15px !important;
}

.drop-menu-item {
  margin: 0 0 0 50px;
}
.claim-item {
  font-size: 15px;
  font-weight: 300;
  line-height: 1;
  letter-spacing: 0.02em;
  font-family: 'Source Sans Pro', sans-serif;
  margin-left: 30px;
}

.centered-label {
  display: flex;
  justify-content: center;
  flex-direction: column;
}
.list-container {
  height: 264px;
  overflow-y: auto;
  font-size: 11pt;
  border: 1px solid rgba(0, 0, 0, .12);
}
.autocomplete-result {
  background-image: none !important;
  padding-left: 10px !important;
}

.table_wrapper {
    display: block;
    overflow-x: auto;
    white-space: nowrap;
}

.required::after {
  display: none !important;
}

/* enables use of tabular figures */
.v-list-item__title {
    font-feature-settings: 'tnum' !important;
}

.select-revision {
  max-width: 300px !important;
}

</style>

<style>

.table {
  white-space: wrap !important;
}

.table.table-scroll {
  display: inline-table !important;
}

.editor-statusbar .lines:before {
  content: 'редови: ' !important;
}

.editor-statusbar .words:before {
  content: 'речи: ' !important;
}
</style>
